import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=b68e2eee&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=b68e2eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68e2eee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b68e2eee')) {
      api.createRecord('b68e2eee', component.options)
    } else {
      api.reload('b68e2eee', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=b68e2eee&scoped=true&", function () {
      api.rerender('b68e2eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zkEf7PmHSHsA/JS/comp/PopupBox.vue"
export default component.exports